<template>
  <article class="user_view">
    <left-menu/>
    <Modal-Comments :data="objJustification" @cancel="hideModalComments" v-if="modalComments" />
    <section class="user_view__header" :class="{'user_view__header--bggrey': greyPage}">
      <div @click="$router.go(-1)" class="back_button">
        <img src="./../../assets/img/icons/back-button.svg">
        <span>atrás</span>
      </div>
      <div class="user_view__header--info"> 
        <section class="user_view__sections">
          <div class="user_view__sections__section">
            <p class="user_view__sections__section__title">Foto</p>
            <div class="user_view__sections__section__content user_view__sections__section__content--image">
              <img :src="turn.turn_img.url" @load="loadImg" id="turnImg" v-show="turnImg"/>
              <img :src="turn.turn_img.url1" @load="loadImg" v-show="turnImg1" id="turnImg1"/>
              <img :src="turn.turn_img.url2" @load="loadImg" v-show="turnImg2" id="turnImg2"/>
              <img :src="turn.turn_img.url3" @load="loadImg" v-show="turnImg3" id="turnImg3"/>
            </div>
          </div>
          <div class="user_view__sections__section user_view__sections__section--full-width">
            <p class="user_view__sections__section__title">Informacion del guarda</p>
            <div class="user_view__sections__section__content" style="width: 650px;">
              <div class="user_view__sections__section__content--guard-info">
                <h2>{{turn.guard.name}} {{turn.guard.last_name}}</h2>
                <h4>CC. {{turn.guard.id_card}}</h4>
              </div>
              <div class="user_view__header--info--item">
                <h3>Fecha: </h3>
                <h4>{{turn.start_date|stringDateYear}}</h4>
              </div>
              <div class="user_view__header--info--item">
                <h3>Hora: </h3>
                <div style="color:white;font-family: Inter UI Bold;font-size: 11px;margin-left: 10px;" :class="is_diurnal? 'turn_calendar__day-box__turns--day':'turn_calendar__day-box__turns--night'">
                    {{turn.start_hour}} - {{turn.end_hour}}
                      <span>
                        <p>{{turn.device.company}}</p>
                        {{turn.device.location}}
                      </span>
                </div>
              </div>
              <div class="user_view__header--info--item">
                <h3>Dispositivo: </h3>
                <h4>{{turn.device.name}}</h4>
              </div>
              <div class="user_view__header--info--item">
                <h3>Coordinador: </h3>
                <h4>{{turn.coordinator.name}} {{turn.coordinator.last_name}}</h4>
              </div>
            </div>
          </div>
        </section>

         <section class="user_view__sections">
          <div class="user_view__sections__section">
            <p class="user_view__sections__section__title">Reporte Horario</p>
            <div class="user_view__sections__section__content user_view__sections__section__content--hours"  style="height: 400px; padding-top: 10px;overflow-y:scroll">
               <table id="reportes" class="info_table__reportsTable">
                <tr class="info_table__reportsTable__header" >
                  <th class="info_table__header--hour">Hora</th>
                  <th class="info_table__header--guard-name">Reporte Guarda</th>                  
                  <th class="info_table__header--guard-justification">Justificación Operario</th>
                  <th></th>
                </tr>
                <tr div v-for="(hours,index) in reports" :key="index" class="info_table__reportsTable__striped">
                   <th style="padding-left: 25px;">
                    <p >{{hours.hour}}:00</p>
                  </th>
                  <th style="padding-left: 30px;">
                    <input  type="checkbox"  v-if="!hours['guard']" disabled >
                    <input   type="checkbox"  v-if="hours['guard']" disabled checked > 
                  </th>
                  <th style="padding-left: 30px;" v-if="!hours['guard']">
                    <input   type="checkbox"  v-if="!hours['justified']" disabled >
                    <input    type="checkbox"  v-if="hours['justified']" disabled checked > 
                  </th>
                  <th style="cursor:pointer" @click="getJustification(hours)" v-if="hours.whoreviews != null">
                    <img src="@/assets/img/icons/comment-alt-regular.svg" style="width: 15px" title="Comentarios...">
                  </th>            
                </tr>
              </table>
            </div>
          </div>
          <div class="user_view__sections__section user_view__sections__section--full-width">
            <p class="user_view__sections__section__title">Audios y Evidencias fotográficas</p>
            <div class=" user_view__sections__section__content user_view__sections__section__content--reports">
              <div class="user_view__audios">
                  <tap-item v-for="(tab, index) in tabs" 
                  :key="index" 
                  :title="tab.title"
                  :image="tab.image"
                  :borderColor="tab.borderColor"
                  @click.native="currentTap = index"
                  :active="index === currentTap"
                  ></tap-item>
              </div>
              <div style="width: 611px;">
                <div style="height:calc(400px - 42px); background-color: white; overflow-y: scroll;">
                  <!-- <div>
                    <div v-for="audio in losAudios" :key="audio">
                      <audio controls="controls" class="user_view__audioItem--audio"><source :src="audio.link1.url" type="audio/wav"></audio>
                      <audio controls="controls" class="user_view__audioItem--audio"><source :src="audio.link2.url" type="audio/wav"></audio>
                      <audio controls="controls" class="user_view__audioItem--audio"><source :src="audio.link3.url" type="audio/wav"></audio>
                      <audio controls="controls" class="user_view__audioItem--audio"><source :src="audio.link4.url" type="audio/wav"></audio>
                    </div>
                  </div> -->
                  <div v-if="currentTap == 0">
                    <report-list
                    :data="audios.high"
                    :loading="loading"
                    :error="error"
                    ></report-list>
                  </div>
                  <div v-else-if="currentTap == 1">
                    <report-list
                    :data="audios.normal"
                    :loading="loading"
                    color="#AEB0B9"
                    :error="error">
                    </report-list>
                  </div>
                  <div v-else-if="currentTap == 2">
                     <report-list
                      type="image"
                      :data="turn.photos"
                      :loading="loading"
                      :error="error">
                     </report-list>
                  </div>
                  <div v-if="currentTap === 3">
                     <report-list
                     type="alert"
                     :data="turn.alerts"
                     :loading="loading"
                     :error="error">
                     </report-list>
                  </div>
                </div>
            </div>
            </div>
          </div>
        </section>
      </div>
    </section>
    
  </article>
</template>

<script>

import moment from 'moment';
import ReportList from '../shared/ReportList'
import Photos from '../shared/PhotosList'
import ReportError from '../shared/ReportsError'
export default {
  components:{
    'report-list': ReportList,
    'photos-list': Photos,
    'report-error': ReportError
  },
  computed:{
    greyPage(){
      return this.$route.name==='GuardTurn'
    }
  },
  data(){
    return{
      loading: true,
      currentTap: 1,
      error: false,
      tabs: [
        {
          title: 'Audios de importancia',
          image: require('../../assets/img/icons/microphone-black-shape-red.svg'),
          borderColor: '#FC3E3B'
        },
        {
          title: 'Audios de reporte',
          image: require('../../assets/img/icons/microphone-black-shape-green.svg'),
          borderColor: '#00DD80'
        },
        {
          title: 'Evidencia fotográfica',
          image: require('../../assets/img/icons/photo-camera.svg'),
          borderColor: '#282E3F'
        },
        {
          title: 'Alertas localización',
          image: require('../../assets/img/icons/alert-rhombus.svg'),
          borderColor: 'yellow'
        }
      ],
      subtitulo:'Guarda           Radio Operador',
      reports:[],
      reportes:{},
      is_diurnal: true,
      turn: {
        guard:{
          name: '',
          last_name:''
        },
        device:{
          company:'',
          name:''
        },
        coordinator:{
          name:'',
          last_name:''
        },
        turn_img:{
          url:''
        },
        audios:[],
        report:{},
        photos:[],
        alerts:[]
      },
      audios:{high:[],normal:[]},
      turnImg: false,
      turnImg1: false,
      turnImg2: false,
      turnImg3: false,
      objJustification: {},
      modalComments: false
    }
  }, 
  methods:{
    calculo(index){      
      var keys=Object.keys(this.turn.report); 
      if(index==keys[keys.length-1]){
        return true;
      }
      else{
        return false;
      }
    },
    loadImg(e){
      
      e.target.id == "turnImg" ? this.turnImg = true : '';
      e.target.id == "turnImg1" ? this.turnImg1 = true : '';
      e.target.id == "turnImg2" ? this.turnImg2 = true : '';
      e.target.id == "turnImg3" ? this.turnImg3 = true : '';
    },
    getJustification(obj){
      this.objJustification = {
        whoreviews: obj.whoreviews,
        comments: obj.comments
      }
      this.modalComments = true;

    },
    hideModalComments(val){
      this.modalComments = false;
    }
  },

  watch:{
    currentTap(value){
      this.loading=true;
      this.$nextTick(() => {
        this.currentTap=value;
        this.loading=false
      })
    }
  },
  created(){
    const customActions={
        get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'PATCH'}                   
    };
    this.$resource('turns/'+this.$route.params.id,{},customActions).get()
    .then(function(data){
      //console.log(data.body.turns);
      //this.unprocessedTurns=data.body.turns;
      //this.table = data.body.table;
      this.turn = data.body; 

      console.log('esstos turn =====', data)
      
      if (Object.keys(this.turn.turn_img).length > 1) {
        this.turn.turn_img.url = (this.turn.turn_img.url).indexOf("#") > 0 ? (this.turn.turn_img.url).replace('#', '%23') : this.turn.turn_img.url;
        this.turn.turn_img.url1 = (this.turn.turn_img.url1).indexOf("#") > 0 ? (this.turn.turn_img.url1).replace('#', '%23') : this.turn.turn_img.url1;
        this.turn.turn_img.url2 = (this.turn.turn_img.url2).indexOf("#") > 0 ? (this.turn.turn_img.url2).replace('#', '%23') : this.turn.turn_img.url2;
        this.turn.turn_img.url3 = (this.turn.turn_img.url3).indexOf("#") > 0 ? (this.turn.turn_img.url3).replace('#', '%23') : this.turn.turn_img.url3;
      }else{
        this.turn.turn_img.url = (this.turn.turn_img.url).indexOf("#") > 0 ? (this.turn.turn_img.url).replace('#', '%23') : this.turn.turn_img.url;
      }

      

      let high = this.turn.audios.filter(audio=> audio.importance>0);
      let normal = this.turn.audios.filter(audio=> audio.importance==0);

      this.audios.high=high.reverse();
      this.audios.normal=normal.reverse();
      this.turn.photos=data.body.photos


      this.turn.audios.high=data
      this.is_diurnal=data.body.is_diurnal;      
      this.reportes=this.turn.report;
      this.justification=this.turn.justification;
      // console.log(this.reportes);
      // console.log(this.justification)
      var self=this;
      var pos=-1;
      this.justification.forEach(function(element){ 
        
        if(self.reportes[element.hour]){
          self.reportes[element.hour]["guard"]=(element.guard);
          self.reportes[element.hour]["justified"]=(element.justified);
        }
        let hours= self.reports.map(report => Number(report.hour));
        if(hours.includes(element.hour-1)){
          self.reports.splice(pos,0,element);
          pos+=1;
        }else{
          self.reports.unshift(element);
          pos=1;
        }
        
      }); 
      this.loading = false
    }).catch(function(e){
      this.error = true
      this.loading = false
      console.log('Error', e)
    });
    
  },
  
}
</script>


// WEBPACK FOOTER //
// src/components/pages/Turn.vue